var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"atalho",style:({ height: _vm.$i18n._vm.locale === "en" ? "100px" : "90px" }),on:{"click":_vm.irParaRota}},[_c('section',{staticClass:"atalho__imagem"},[_c('img',{attrs:{"src":_vm.atalho.linkIcone,"alt":"atalho","height":"100%","width":"100%"}})]),_c('section',{staticClass:"atalho__titulo"},[_vm._v(_vm._s(_vm.atalho.nome))])])
}
var staticRenderFns = []

export { render, staticRenderFns }